import * as tslib_1 from "tslib";
import Vue from "vue";
import robotLoader from "@/components/robotLoader.vue";
import downloadButton from "@/components/downloadButton.vue";
import { Getter, Action } from "vuex-class";
import { Component } from "vue-property-decorator";
let App = class App extends Vue {
    constructor() {
        super(...arguments);
        this.msg = "Loading...";
    }
    created() {
        const w = window;
        w.document.title = process.env.VUE_APP_TITLE;
    }
    get loading() {
        return this.rootState || this.authState || this.navState || this.msg;
    }
    get loadingMsg() {
        return this.authState || this.navState || this.rootState || this.msg; // note priority of state to display
    }
    get showToolbar() {
        return !this.loading && this.$route.meta.hideToolbar !== true;
    }
    get languages() {
        const langs = this.$t("languages");
        return Object.keys(langs).map(k => {
            return { value: k, text: String(langs[k]) };
        });
    }
    get showBreakpointText() {
        return process.env.NODE_ENV == "development";
    }
    async mounted() {
        // init application
        try {
            await this.$store.dispatch("init");
        }
        catch (err) {
            if (err !== "need_login") {
                console.log("init err:", err);
                if (err.message) {
                    alert(err.message);
                }
                else {
                    alert(err);
                }
            }
        }
        this.msg = "";
    }
    get currYear() {
        return (new Date()).getFullYear();
    }
    reload() {
        window.location.href = window.location + "/";
    }
    gotoWeb() {
        this.msg = String(this.$t("loading"));
        this.gotoDBTrackWeb();
    }
};
tslib_1.__decorate([
    Action("gotoDBTrackWeb")
], App.prototype, "gotoDBTrackWeb", void 0);
tslib_1.__decorate([
    Getter("state")
], App.prototype, "rootState", void 0);
tslib_1.__decorate([
    Getter("auth/state")
], App.prototype, "authState", void 0);
tslib_1.__decorate([
    Getter("nav/state")
], App.prototype, "navState", void 0);
tslib_1.__decorate([
    Getter("auth/canDownloadData")
], App.prototype, "canDownloadData", void 0);
tslib_1.__decorate([
    Getter("tzName")
], App.prototype, "tzName", void 0);
tslib_1.__decorate([
    Getter("lastErr")
], App.prototype, "lastErr", void 0);
App = tslib_1.__decorate([
    Component({
        name: "App",
        components: {
            "robot-loader": robotLoader,
            "download-button": downloadButton
        }
    })
], App);
export default App;
// <template>
//   <div id="app">
//     <div id="nav">
//       <router-link to="/">Home</router-link> |
//       <router-link to="/about">About</router-link>
//     </div>
//     <router-view/>
//   </div>
// </template>
// <style lang="scss">
// #app {
//   font-family: 'Avenir', Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }
// #nav {
//   padding: 30px;
//   a {
//     font-weight: bold;
//     color: #2c3e50;
//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
// </style>
